import BannerEventLogger from './BannerEventLogger.js';
import BannerUtils from './BannerUtils.js';

const ALLOWED_SSA_PRODUCT = ['netboard_2', 'board_2'];
const ALLOWED_TAKOVER = ['board_2'];

class BannerContext {
    constructor(apntag, radio, sitesettings, trackingservice) {
        this._apntag = apntag;
        this._appNexusData = null;
        this._allowedSSAProductTags = ALLOWED_SSA_PRODUCT;
        this._allowedTakeoverTags = ALLOWED_TAKOVER;

        this._radio = radio;
        this._sitesettings = sitesettings;
        this._trackingservice = trackingservice;

        // initialization depends on trackingservice
        this._logger = new BannerEventLogger(this);
    }

    // APPNEXUS: create apntag object
    initApnTag() {
        window.apntag = window.apntag || {
            onEvent: () => {},
            offEvent: () => {},
        };
        this._apntag = window.apntag;
        this._apntag.anq = this._apntag.anq || [];
    }

    // APPNEXUS: load request data
    initAppNexusData(result) {
        if (result && result.bannerData && result.bannerData.appNexusJson) {
            this._appNexusData = JSON.parse(result.bannerData.appNexusJson);
        } else {
            this._appNexusData = BannerUtils.getAppNexusData();
        }

        this._setExternalUid();

        window.FINN = window.FINN || {};
        window.FINN.banner = window.FINN.banner || {};
        window.FINN.banner.feed = this._appNexusData.feed;
        window.FINN.banner.feedString = this._appNexusData.feedString;
        window.FINN.banner.ssa = this._appNexusData.ssa;
    }

    _setExternalUid() {
        if (this._appNexusData.pageOpts) {
            this._appNexusData.pageOpts.user = {
                externalUid: BannerUtils.getAdId(),
            };
        }
        this._apntag.anq.push(() => {
            this._apntag.setPageOpts(this._appNexusData.pageOpts);
        });
    }

    // ************ GETTER/SETTER
    set apntag(value) {
        this._apntag = value;
    }

    set appNexusData(value) {
        this._appNexusData = value;
    }

    set allowedSSAProductTags(value) {
        this._allowedSSAProductTags = value;
    }

    set allowedTakeoverTags(value) {
        this._allowedTakeoverTags = value;
    }

    set radio(value) {
        this._radio = value;
    }

    set sitesettings(value) {
        this._sitesettings = value;
    }

    set trackingservice(value) {
        this._trackingservice = value;
    }

    set logger(value) {
        this._logger = value;
    }

    get apntag() {
        return this._apntag;
    }

    get appNexusData() {
        return this._appNexusData;
    }

    get allowedSSAProductTags() {
        return this._allowedSSAProductTags;
    }

    get allowedTakeoverTags() {
        return this._allowedTakeoverTags;
    }

    get radio() {
        return this._radio;
    }

    get sitesettings() {
        return this._sitesettings;
    }

    get trackingservice() {
        return this._trackingservice;
    }

    get logger() {
        return this._logger;
    }
}

export default BannerContext;



// WEBPACK FOOTER //
// ./services/banner2/BannerContext.js